import { ChangeEvent } from 'react'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import ChevronDownIcon from '~/components/Icons/svgs/ChevronDownIcon'
import { NewsType } from '~/types/media'

import useMediaNewsNav from './useMediaNewsNav'
import MediaNewsNavItem from './MediaNewsNavItem'

export default function MediaNewsNav({
  onClick,
  selectedType,
}: {
  onClick: (type: NewsType) => void
  selectedType: NewsType
}): React.ReactElement {
  const items = useMediaNewsNav()

  function handleOnChange(event: ChangeEvent<HTMLSelectElement>): void {
    onClick(event.target.value as NewsType)
  }

  return (
    <nav className="mb-8">
      <div className="lg:hidden relative inline-block">
        <select className="font-medium appearance-none pr-6" onChange={handleOnChange} value={selectedType}>
          {items.map((elem) => (
            <option key={elem.key} value={elem.key}>
              {elem.label}
            </option>
          ))}
        </select>
        <div className="absolute top-1/2 right-0 transform -translate-y-1/2 pointer-events-none">
          <span className="p-1 flex items-center justify-center rounded-full bg-blue-iris">
            <SVGIcon icon={ChevronDownIcon} pathClassName="text-white" size={12} />
          </span>
        </div>
      </div>

      <div className="hidden lg:flex justify-center space-x-2">
        {items.map(({ key, label }) => (
          <MediaNewsNavItem isActive={selectedType === key} key={key} onClick={() => onClick(key)}>
            {label}
          </MediaNewsNavItem>
        ))}
      </div>
    </nav>
  )
}
